import { Spinner, Stack } from '@stitch-fix/mode-react';
export const LoadingSpinner = () => <Stack spacing={1.5} hAlign="center" m={4}>
    <Spinner aria-label="Loading" size="xlarge" />
  </Stack>;